import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

const InfoItem = ({ label, value }) => (
  <Grid item xs={12} md={6}>
    <MDTypography variant="body2" color="text">
      <strong>{label}:</strong> {value ?? "N/A"}
    </MDTypography>
  </Grid>
);

InfoItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function LogisticsDetailContent({ logistics }) {
  if (!logistics) return null;

  const formatDateTime = (value) => {
    if (!value) return "N/A";
    try {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value;
      }
      return date.toLocaleDateString("tr-TR");
    } catch (error) {
      return value;
    }
  };

  return (
    <MDBox>
      {logistics.logisticsInvoice && (
        <MDBox mt={2}>
          <MDTypography variant="h6" fontWeight="medium" gutterBottom>
            Lojistik Fatura Bilgileri
          </MDTypography>
          <Grid container spacing={2}>
            <InfoItem label="Statü" value={logistics.logisticsInvoice.status} />
            <InfoItem label="Toplam Tutar" value={logistics.logisticsInvoice.totalAmount} />
          </Grid>
        </MDBox>
      )}

      <MDBox mt={3}>
        <MDTypography variant="h6" fontWeight="medium" gutterBottom>
          Lojistik Bilgileri
        </MDTypography>
        <Grid container spacing={2}>
          <InfoItem label="Tarih" value={formatDateTime(logistics.agreedArrivalTime)} />
          <InfoItem label="Güncel Statü" value={logistics.status} />
          <InfoItem label="Oluşturan" value={logistics.createdByName || logistics.createdById} />
        </Grid>
      </MDBox>

      {logistics.vehicles?.length > 0 && (
        <MDBox mt={3}>
          <MDTypography variant="h6" fontWeight="medium" gutterBottom>
            Araç Bilgileri
          </MDTypography>
          {logistics.vehicles.map((vehicle, index) => (
            <MDBox
              key={vehicle.id || index}
              mb={2}
              p={2}
              borderRadius={2}
              border="1px solid"
              borderColor="grey.200"
            >
              <MDTypography variant="button" fontWeight="bold">
                Araç {index + 1}
              </MDTypography>
              <Grid container spacing={1} mt={1}>
                <InfoItem label="Dorse Plaka" value={vehicle.dorsePlaka} />
                <InfoItem label="Çekici Plaka" value={vehicle.cekiciPlaka} />
                <InfoItem label="Tır Tipi" value={vehicle.tirTipi} />
                <InfoItem label="Şoför Adı" value={vehicle.soforAdi} />
                <InfoItem label="Şoför Telefon" value={vehicle.soforTelefon} />
                <InfoItem label="Şoför Kimlik" value={vehicle.soforKimlik || "-"} />
              </Grid>
            </MDBox>
          ))}
        </MDBox>
      )}
    </MDBox>
  );
}

LogisticsDetailContent.propTypes = {
  logistics: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    agreedArrivalTime: PropTypes.string,
    status: PropTypes.string,
    createdById: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    createdByName: PropTypes.string,
    logisticsInvoice: PropTypes.shape({
      status: PropTypes.string,
      totalAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    vehicles: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        dorsePlaka: PropTypes.string,
        cekiciPlaka: PropTypes.string,
        tirTipi: PropTypes.string,
        soforAdi: PropTypes.string,
        soforTelefon: PropTypes.string,
        soforKimlik: PropTypes.string,
      })
    ),
  }),
};

export default LogisticsDetailContent;
